(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('init-value', {
                parent: 'entity',
                url: '/init-value',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Init Values'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/init-value/list/init-value.html',
                        controller: 'InitValueController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
